<app-topbar (menuToggle)="toggleSidebar()"></app-topbar>

<div class="dashboard-wrapper">
  <mat-sidenav-container class="dashboard-container">
    <mat-sidenav #sidenav mode="side" [opened]="isSidebarOpened" class="sidebar">
      <app-sidebar></app-sidebar>
    </mat-sidenav>

    <mat-sidenav-content>
      <main class="dashboard-content">
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>